/**
 *  @enum LvfHandlingEnergyType
 *  @classdesc Represents the supported Handling energy type.
 */
export enum LvfHandlingEnergyType {

  FIOUL = 1,
  ELECTRIC = 2,
  GAZ = 3,
  MANUEL = 4,
}
